var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientInternalPayrollIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62141 2.63704V0.257812L4.24219 2.63704H6.62141Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.51562H3.98438V5.31784C5.47119 5.53333 6.62109 6.80408 6.62109 8.34961C6.62109 9.43073 6.05736 10.3792 5.21141 10.928C6.16344 11.3741 6.90113 12.1853 7.25704 13.1836H14.5312V0H7.5V3.51562ZM12.7734 11.4258H7.5V10.5469H12.7734V11.4258ZM12.7734 9.66797H7.5V8.78906H12.7734V9.66797ZM10.5762 5.27344C9.84924 5.27344 9.25781 4.68201 9.25781 3.95508C9.25781 3.38287 9.62631 2.8997 10.1367 2.71763V1.75781H11.0156V2.71763C11.526 2.8997 11.8945 3.38287 11.8945 3.95508H11.0156C11.0156 3.71258 10.8187 3.51562 10.5762 3.51562C10.3337 3.51562 10.1367 3.71258 10.1367 3.95508C10.1367 4.19758 10.3337 4.39453 10.5762 4.39453C11.3031 4.39453 11.8945 4.98596 11.8945 5.71289C11.8945 6.2851 11.526 6.76826 11.0156 6.95034V7.91016H10.1367V6.95034C9.62631 6.76826 9.25781 6.2851 9.25781 5.71289H10.1367C10.1367 5.95539 10.3337 6.15234 10.5762 6.15234C10.8187 6.15234 11.0156 5.95539 11.0156 5.71289C11.0156 5.47039 10.8187 5.27344 10.5762 5.27344Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74219 8.34961C5.74219 9.56314 4.75845 10.5469 3.54492 10.5469C2.33139 10.5469 1.34766 9.56314 1.34766 8.34961C1.34766 7.13608 2.33139 6.15234 3.54492 6.15234C4.75845 6.15234 5.74219 7.13608 5.74219 8.34961Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54492 11.4258C1.84605 11.4258 0.46875 12.8324 0.46875 14.5312V15H6.62109V14.5312C6.62109 12.8324 5.2438 11.4258 3.54492 11.4258Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInternalPayrollIcon);
export default __webpack_public_path__ + "static/media/client-internal-payroll-icon.4d048377.svg";
export { ForwardRef as ReactComponent };